import { render, staticRenderFns } from "./RegoSearchForm.vue?vue&type=template&id=6887f34c&"
import script from "./RegoSearchForm.vue?vue&type=script&lang=js&"
export * from "./RegoSearchForm.vue?vue&type=script&lang=js&"
import style0 from "./RegoSearchForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports